import { recordId } from './recordId';

interface TaskLike { id: string }

/** Chip text for each dependency. One that is not in the pick list (archived, trashed) shows its short id. */
export function dependencyLabels<T extends TaskLike>(ids: string[], tasks: T[], labelOf: (t: T) => string): string[] {
  return ids.map(id => {
    const t = tasks.find(ot => ot.id === id);
    return t ? labelOf(t) : recordId('TA', id);
  });
}

/** Ids for the chips left after an edit. Chips for unresolved dependencies map back to their ids, so they are kept. */
export function dependencyIdsFromLabels<T extends TaskLike>(labels: string[], currentIds: string[], tasks: T[], labelOf: (t: T) => string): string[] {
  const unresolved = new Map(currentIds.filter(id => !tasks.some(t => t.id === id)).map(id => [recordId('TA', id), id]));
  return labels
    .map(l => tasks.find(t => labelOf(t) === l)?.id ?? unresolved.get(l))
    .filter((id): id is string => Boolean(id));
}
